import { Component,OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../common/global-variables';
import { VcaAlertsService } from '../../../../common/vca-alerts/vca-alerts.service';
import { Subscription } from 'rxjs/Rx';
import { RefreshSharedService } from '../../../refresh-shared-service';
import { AuthService } from '../../../auth/auth.service';
import { DiceIntegrationService } from './dice-integration.service';
import { NspUpgradeService } from '../../../../../src/publisher/src/publisher-ui/upgrade/nsp-upgrade.service';
import { HttpUtils } from '../../../../common/http/http-utils';
import { environment } from 'environments/environment';

const _ = require('lodash');
const SUCCESS = "Succeeded";
const SAVESUCCESSMESSAGE = "SUCCESS";
const FAIL = "Failed";

@Component({
    selector: 'dice-intergration',
    styles: [require('./dice-integration.scss')],
    templateUrl: './dice-integration.html',
    providers: [DiceIntegrationService]
})

export class DiceIntegrationComponent implements  OnInit {

    private diceService:DiceIntegrationService;
    private uploadInProgress: boolean = false;
    private uploadBtnText: string = "Upload VC Inventory to DICE";
    private saveInProgress: boolean = false;
    private saveBtnText: string = "Save";
    private showSuccessBanner: boolean = false;
    private showFailBanner: boolean = false;
    private showUploadSection: boolean = false;
    private statusMessage: string = "";

    private showStatusBanner: boolean = false;
    private showLastStatusError: boolean = false;
    private showLastStatusSuccess: boolean = false;
    private generateFileInProgress: boolean  = false;

    private generateFileStatusMessage: string = "";
    private genearateFileShowStatusBanner: boolean = false;
    private generateFileError: boolean = false;
    private generateFileSuccess: boolean = false;
    private generatedFileLocation: string = "";
    private generatedFileName: string = "";
    private preserveFileTill: number = 3600000;
    preparingDownload = false;

    private dataModel = {
        apiKey: '',
        apiSecret: '',
        customerId: '',
        modelId: '',
        collectionId : ''
    }

    private statusModel = {
        lastUploadTimeStamp: '',
        lastSuccessfulUploadTimeStamp: '',
        lastUploadResponseResult: null,
    }

    constructor(private service: DiceIntegrationService, private translate: TranslateService,
        private alert: VcaAlertsService, private rss: RefreshSharedService, public authService: AuthService,public nspUpgradeSvc: NspUpgradeService) {
            this.diceService = service;
    }


    ngOnInit() {
        this.getConfiguration();
        this.showStatus();
    }

    private getConfiguration(){
        console.log("Called again : ")
        this.diceService.getDiceConfigruation().subscribe(
            (response:any) => {
                let configuration = response;
                console.log("Response : ", response);
                if(configuration.hasOwnProperty("customerId")){
                    this.showUploadSection = true;
                    this.dataModel.apiKey = configuration.apiKey;
                    this.dataModel.apiSecret = configuration.apiSecret;
                    this.dataModel.customerId = configuration.customerId;
                    this.dataModel.modelId = configuration.modelId;
                    this.dataModel.collectionId = configuration.collectionId;
                } else {
                    this.showUploadSection = false;
                }
            },
            (error) => {

            }
        )
    }

    private showStatus(){
        this.diceService.getStatus().subscribe((response:any)=>{
            let responseJson = response;
            if(responseJson.lastStatus.status !== SUCCESS && responseJson.lastStatus.status !== FAIL){
                this.showStatus();
            } else {
                if(responseJson.lastStatus.type === 'download'){
                    this.showDownloadStatus(responseJson);
                    this.generateFileInProgress = false
                } else {
                    this.showUploadStatus(responseJson);
                    this.uploadInProgress = false;
                    this.uploadBtnText = "Upload VC Inventory to DICE";
                }

            }
        })
    }

    private saveSettings(){
        this.saveInProgress = true;
        this.saveBtnText = "Saving";
        this.disableStatusBanner();
        this.diceService.saveDiceConfiguration(this.dataModel).subscribe((response:any)=>{
            let responseJson = response;
            if(responseJson.status !== SAVESUCCESSMESSAGE){
                this.statusMessage = "Error while saving DICE configuration."
                this.showFailBanner = true;
                this.showSuccessBanner = false;
            } else {
                this.statusMessage = "Successfully saved DICE configuration";
                this.showSuccessBanner = true;
                this.showFailBanner = false;
            }
            this.saveInProgress = false;
            this.saveBtnText = "Save";
            this.showUploadSection = true;
            this.getConfiguration();
        },
        (error) => {

        })
    }

    private resetSettings(){
        let dataModel = {
            apiKey: '',
            apiSecret: '',
            customerId: '',
            modelId: '',
            collectionId: ''
        };
        this.dataModel = dataModel;
    }

    private uploadDiceData(){
        const localEndpoint = this.nspUpgradeSvc.getLocalHcmReference();
        let vcURL = localEndpoint.url;
        this.uploadInProgress = true;
        this.uploadBtnText = "Uploading";
        this.disableStatusBanner();
        this.diceService.uploadDiceData(vcURL).subscribe((response)=> {
            this.showStatus();
        });
    }

    private disableStatusBanner(){
        this.showSuccessBanner = false;
        this.showFailBanner = false;
    }

    private generateInventoryDownloadFile(){
        const localEndpoint = this.nspUpgradeSvc.getLocalHcmReference();
        let vcURL = localEndpoint.url;
        this.diceService.generateInventoryFileToDownload(vcURL).subscribe((response)=>{
            this.generateFileSuccess = false;
            this.generateFileError = false;
            this.generateFileInProgress = true;
            this.showStatus();
        });
    }

    private showUploadStatus(responseJson){
        this.showStatusBanner = true;
        if(responseJson.lastStatus.status == FAIL){
            var failDate = new Date(Number(responseJson.lastStatus.timeStamp));
            this.statusModel.lastUploadTimeStamp = "" + failDate.getDate() + "-"+ failDate.getMonth() + "-" + failDate.getFullYear() + " : " + failDate.getHours() + ":" + failDate.getMinutes() + ":" + failDate.getSeconds();
            this.statusModel.lastUploadResponseResult = responseJson.lastStatus.responseResult;
            this.showLastStatusError = true;
            this.showLastStatusSuccess= false;
            this.statusMessage = "Failed to upload data to DICE." + responseJson.lastStatus.responseResult;
            this.showFailBanner = true;
        }
        else if(responseJson.lastStatus.status == SUCCESS){
            this.showLastStatusSuccess= true;
            this.showLastStatusError = false;
            var successDate = new Date(Number(responseJson.lastSuccessfulStatus.timeStamp))
            this.statusModel.lastSuccessfulUploadTimeStamp = "" + successDate.getDate() + "-"+ successDate.getMonth() + "-" + successDate.getFullYear() + " : " + successDate.getHours() + ":" + successDate.getMinutes() + ":" + successDate.getSeconds();
            this.statusMessage = "Data uploaded successfully  to DICE.";
            this.showSuccessBanner = true;
            this.getConfiguration();
        }
    }

    private showDownloadStatus(responseJson){
        this.genearateFileShowStatusBanner = true;
        if(responseJson.lastStatus.status === SUCCESS){
            var currentTime = new Date().getTime();
            if(currentTime - responseJson.lastStatus.timeStamp < this.preserveFileTill) {
                this.generateFileSuccess = true;
                this.generatedFileLocation = HttpUtils.getSiteUrl()  + "/hybridity/api/dice/download/" + responseJson.lastStatus.fileName;
                this.generatedFileName = responseJson.lastStatus.fileName;
            }
        }
        else{
            this.generateFileError = false;
        }
    }

    downloadFile(e) {
        e.preventDefault();
        this.showFailBanner = false;
        if(this.generatedFileLocation && this.generatedFileName) {
            this.preparingDownload = true;
            fetch(this.generatedFileLocation, {
                headers:{
                    'x-hm-authorization': environment.token ? atob(environment.token) : null
                }
            })
            .then((response) => response.blob())
            .then((blob) => {
                this.preparingDownload = false;
                var _url = window.URL.createObjectURL(blob);
                const elem = document.createElement('a');
                elem.setAttribute('display', 'none');
                elem.setAttribute('href', _url);
                elem.setAttribute('download', this.generatedFileName);
                // fix for firefox browser, as firefox don't entertain click on elements not attached to DOM.
                document.querySelector('body').appendChild(elem);
                elem.click();
                elem.remove();
            })
            .catch((err) => {
                this.preparingDownload = false;
                this.statusMessage = "Failed to Download file " + this.generatedFileName;
                this.showFailBanner = true;
            });
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/components/administration-main/dice-integration/dice-integration.component.ts